import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import logoCentrao from '../assets/logo-centrao.png';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [modo, setModo] = useState('login'); // 'login' | 'esqueci'
  const [username, setUsername] = useState('');
  const [senha, setSenha] = useState('');
  const [verSenha, setVerSenha] = useState(false);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [msgOk, setMsgOk] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);
    try {
      await login(username.trim(), senha);
      navigate(loc.state?.de || '/', { replace: true });
    } catch (err) {
      setErro(err.response?.data?.error || 'Não foi possível entrar. Confira usuário e senha.');
    } finally {
      setCarregando(false);
    }
  };

  const enviarReset = async (e) => {
    e.preventDefault();
    setErro('');
    setMsgOk('');
    setCarregando(true);
    try {
      const { data } = await api.post('/auth/esqueci-senha', { username: username.trim() });
      setMsgOk(data?.mensagem || 'Se houver cadastro com esse usuário e e-mail vinculado, enviaremos uma nova senha.');
    } catch {
      // resposta é sempre genérica; se der erro de rede, mostra msg neutra
      setMsgOk('Se houver cadastro com esse usuário e e-mail vinculado, enviaremos uma nova senha.');
    } finally {
      setCarregando(false);
    }
  };

  const irPara = (novo) => { setModo(novo); setErro(''); setMsgOk(''); setSenha(''); };

  return (
    <div className="lf-wrap">
      <div className="lf-card">
        <img src={logoCentrao} alt="Centrão Materiais de Construção" className="lf-logo" />
        <div className="lf-eyebrow">Portal do Fornecedor</div>
        {modo === 'login' ? (
          <>
            <p className="lf-sub">Acompanhe seu mix, amostras e vendas com o Centrão.</p>
            <form className="lf-form" onSubmit={submit}>
              <div className="lf-field">
                <label>Usuário</label>
                <input className="lf-input" type="text" autoComplete="username" value={username}
                  onChange={(e) => setUsername(e.target.value)} placeholder="seu usuário" required />
              </div>
              <div className="lf-field">
                <label>Senha</label>
                <div className="lf-pass">
                  <input className="lf-input" type={verSenha ? 'text' : 'password'} autoComplete="current-password"
                    value={senha} onChange={(e) => setSenha(e.target.value)} placeholder="sua senha" required />
                  <button type="button" className="lf-eye" onClick={() => setVerSenha((v) => !v)}
                    aria-label={verSenha ? 'Ocultar senha' : 'Mostrar senha'}>
                    <i className={`bi ${verSenha ? 'bi-eye-slash' : 'bi-eye'}`} />
                  </button>
                </div>
              </div>
              {erro && (<div className="lf-alert"><i className="bi bi-exclamation-triangle" /> {erro}</div>)}
              <button className="lf-btn" type="submit" disabled={carregando}>
                {carregando ? 'Entrando...' : 'Entrar'}
                {!carregando && <i className="bi bi-arrow-right" />}
              </button>
              <button type="button" className="lf-link" onClick={() => irPara('esqueci')}>Esqueci minha senha</button>
            </form>
          </>
        ) : (
          <>
            <p className="lf-sub">Informe seu usuário e enviaremos uma nova senha para o e-mail cadastrado.</p>
            <form className="lf-form" onSubmit={enviarReset}>
              <div className="lf-field">
                <label>Usuário</label>
                <input className="lf-input" type="text" autoComplete="username" value={username}
                  onChange={(e) => setUsername(e.target.value)} placeholder="seu usuário" required autoFocus />
              </div>
              {msgOk && (<div className="lf-ok"><i className="bi bi-check-circle" /> {msgOk}</div>)}
              {erro && (<div className="lf-alert"><i className="bi bi-exclamation-triangle" /> {erro}</div>)}
              <button className="lf-btn" type="submit" disabled={carregando || !!msgOk}>
                {carregando ? 'Enviando...' : 'Enviar nova senha'}
                {!carregando && <i className="bi bi-send" />}
              </button>
              <button type="button" className="lf-link" onClick={() => irPara('login')}>
                <i className="bi bi-arrow-left" /> Voltar ao login
              </button>
            </form>
          </>
        )}

        <div className="lf-foot">Centrão Materiais de Construção</div>
      </div>

      <style>{`
        .lf-wrap {
          min-height: 100vh; display: flex; align-items: center; justify-content: center;
          padding: 24px;
          background:
            linear-gradient(160deg, #0F3B1F 0%, #16522A 55%, #0C3119 100%);
        }
        .lf-card {
          width: 100%; max-width: 400px; background: #fff; border-radius: 20px;
          padding: 40px 34px 30px; box-shadow: 0 24px 60px rgba(6, 26, 14, 0.35);
          text-align: center; animation: lfUp .5s ease both;
        }
        @keyframes lfUp { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: none; } }
        .lf-logo { width: 200px; max-width: 78%; height: auto; margin: 0 auto 20px; display: block; }
        .lf-eyebrow {
          display: inline-block; font-size: 0.74rem; font-weight: 700; letter-spacing: 0.09em;
          text-transform: uppercase; color: var(--primary);
          background: var(--primary-light); padding: 5px 12px; border-radius: 999px;
        }
        .lf-sub { color: var(--muted); font-size: 0.9rem; margin: 14px 0 22px; }
        .lf-form { display: flex; flex-direction: column; gap: 14px; text-align: left; }
        .lf-field label { display: block; font-size: 0.82rem; font-weight: 600; color: var(--text-suave); margin-bottom: 6px; }
        .lf-input {
          width: 100%; padding: 12px 14px; font-size: 0.98rem; color: var(--text);
          background: #fff; border: 1.5px solid var(--borda); border-radius: 11px;
          outline: none; transition: border-color .15s, box-shadow .15s;
        }
        .lf-input::placeholder { color: #aab4ac; }
        .lf-input:focus { border-color: var(--primary); box-shadow: 0 0 0 3.5px rgba(31,106,45,0.14); }
        .lf-pass { position: relative; }
        .lf-eye {
          position: absolute; right: 6px; top: 50%; transform: translateY(-50%);
          background: none; border: none; color: var(--muted); cursor: pointer; font-size: 1.05rem; padding: 8px;
        }
        .lf-alert {
          display: flex; align-items: center; gap: 8px; font-size: 0.88rem; color: var(--danger);
          background: #fbe6e6; border: 1px solid #f0cccc; padding: 10px 12px; border-radius: 10px;
        }
        .lf-ok {
          display: flex; align-items: center; gap: 8px; font-size: 0.88rem; color: var(--primary-dark, #1F6A2D);
          background: #e6f3ea; border: 1px solid #c3e2cd; padding: 10px 12px; border-radius: 10px;
        }
        .lf-link {
          background: none; border: none; color: var(--primary); font-size: 0.86rem; font-weight: 600;
          cursor: pointer; padding: 6px; margin: 2px auto 0; display: inline-flex; align-items: center; gap: 6px;
        }
        .lf-link:hover { text-decoration: underline; }
        .lf-btn {
          width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 6px;
          padding: 13px; font-size: 1rem; font-weight: 700; color: #fff;
          background: var(--primary); border: none; border-radius: 11px; cursor: pointer;
          box-shadow: 0 8px 20px rgba(31,106,45,0.28); transition: background .15s, transform .15s, box-shadow .15s;
        }
        .lf-btn:hover { background: var(--primary-dark); transform: translateY(-1px); box-shadow: 0 12px 26px rgba(31,106,45,0.34); }
        .lf-btn:disabled { opacity: 0.75; cursor: default; transform: none; }
        .lf-foot { margin-top: 24px; color: #9aa89c; font-size: 0.78rem; }
      `}</style>
    </div>
  );
}
